import { CtrlType, CtrlProps } from "@yuigoto/ctrl";

/**
 * @type {CtrlProps[]}
 */
export const AccountControls = [
  {
    name: "email",
    label: "E-mail",
    type: CtrlType.EMAIL,
    required: true,
    requiredMessage: "Este campo é obrigatório",
    emailMessage: "E-mail inválido!"
  },
  {
    name: "firstName",
    label: "Nome",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Este campo é obrigatório",
  },
  {
    name: "lastName",
    label: "Sobrenome",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Este campo é obrigatório",
  }
];

/**
 * @type {CtrlProps[]}
 */
export const PersonControls = [
  {
    name: "cpf",
    label: "CPF",
    type: CtrlType.CPF,
    required: true,
    requiredMessage: "Este campo é obrigatório",
    cpfMessage: "Número de CPF inválido"
  },
  {
    name: "birthday",
    label: "Data de Nascimento",
    placeholder: "DD/MM/YYYY",
    type: CtrlType.DATE,
    required: true,
    requiredMessage: "Este campo é obrigatório",
    dateMessage: "Data inválida"
  },
  {
    name: "phone",
    label: "Telefone",
    type: CtrlType.PHONE,
    required: true,
    requiredMessage: "Este campo é obrigatório",
    minLength: 10,
    minLengthMessage: "Mínimo 10 dígitos",
    maxLength: 11,
    maxLengthMessage: "Máximo 11 dígitos",
  }
];

/**
 * @type {CtrlProps[]}
 */
export const BillingControls = [
  {
    name: "billingPostalCode",
    label: "CEP",
    type: CtrlType.CEP,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "billingState",
    label: "UF",
    type: CtrlType.HIDDEN,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "billingStateId",
    label: "UF",
    type: CtrlType.DROPDOWN,
    options: [], 
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "billingCity",
    label: "Cidade",
    type: CtrlType.HIDDEN,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "billingCityId",
    label: "Cidade",
    type: CtrlType.DROPDOWN,
    options: [], 
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "billingStreetNeighborhood",
    label: "Bairro",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "billingStreet",
    label: "Endereço",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "billingStreetNumber",
    label: "Nº",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "billingStreetExtension",
    label: "Complemento",
    type: CtrlType.DEFAULT,
    required: false,
    requiredMessage: "Este campo é obrigatório"
  }
];

/**
 * @type {CtrlProps[]}
 */
export const ShippingControls = [
  {
    name: "shippingPostalCode",
    label: "CEP",
    type: CtrlType.CEP,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "shippingState",
    label: "UF",
    type: CtrlType.HIDDEN,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "shippingStateId",
    label: "Cidade",
    type: CtrlType.DROPDOWN,
    options: [], 
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "shippingCity",
    label: "Cidade",
    type: CtrlType.HIDDEN,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "shippingCityId",
    label: "Cidade",
    type: CtrlType.DROPDOWN,
    options: [], 
    required: true
  },
  {
    name: "shippingStreetNeighborhood",
    label: "Bairro",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "shippingStreet",
    label: "Endereço",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "shippingStreetNumber",
    label: "Nº",
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "shippingStreetExtension",
    label: "Complemento",
    type: CtrlType.DEFAULT,
    required: false,
    requiredMessage: "Este campo é obrigatório"
  }
];
